import { initialize } from 'redux-form';
import moment from 'moment';
import { getUserIdForInput } from 'Common';
import { FORM_NAME } from '../Form';
import { getProps } from '../props';
import selectClientContacts from '../Selectors/selectClientContacts';

export default () => async (dispatch, getState) => {

  const { order, estimate, projectId, isCreatingFromEstimate } = getProps();

  if (order) {

    dispatch(initialize(FORM_NAME, order))

  } else if (isCreatingFromEstimate) {

    // match against the loaded contacts list so the value type lines up with the dropdown options
    const clientContacts = selectClientContacts(getState());
    const clientContact = clientContacts.find(item => item.id == estimate.client_contact_id); // eslint-disable-line eqeqeq

    dispatch(initialize(FORM_NAME, {
      project_id: projectId || undefined,
      estimate_id: estimate.id || undefined,
      client_contact_id: (clientContact && clientContact.id) || undefined,
      user_id: getUserIdForInput(),
      date: moment().format('YYYY-MM-DD'),
      discount_percentage: estimate.discount_percentage,
      uplift_percentage: estimate.uplift_percentage,
      vat_percentage: estimate.vat_percentage,
      retention_percentage: 0,
      extra_works: estimate.extra_works
    }));

  } else {

    const project = getState().modals.Order.project;
    const hasExistingOrders = !!(project && project.orders && project.orders.length > 0);

    dispatch(initialize(FORM_NAME, {
      project_id: projectId || undefined,
      user_id: getUserIdForInput(),
      date: moment().format('YYYY-MM-DD'),
      terms_and_conditions_type: 1,
      discount_percentage: 0,
      uplift_percentage: 0,
      vat_percentage: '20',
      retention_percentage: 0,
      extra_works: hasExistingOrders ? 1 : 0  // 0 = New Works, 1 = Extra Works
    }))

  }

}
